var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22 11L13 20L8 15","stroke":"#262626","strokeWidth":"1.6","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Check.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Check;

Check.default = Check;
